/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';

/* Components */
import CatalogVodSkeleton from '../../../../components/CatalogVodSkeleton';
import CardLiveSkeleton from '../../../../components/CardLiveSkeleton';
import ScrollView from '../../../../components/ScrollView';
import CatalogAll from '../../../../components/CatalogAll';

/* Utils */
import useFetchCarousel from '../../../../hooks/useFetchCarousel';
import useCarouselContents from '../../../../hooks/useCarouselContents';
import { CardTypeByCarouselType } from '../../../../utils/cardsUtils';
/* Styles */
import './Section.scss';

function getCardsPerRow(typeCards) {
  if (typeCards === 'LIVE') {
    return 3;
  }

  return 5;
}

function Section({ sourceProvider }) {
  const { sourceCarouselId, source, type } = useParams();
  const { carousel, isFetching } = useFetchCarousel({
    sourceCarouselId,
    source,
    type,
    sourceProvider,
  });
  const items = useCarouselContents(carousel);
  const sectionTitle = carousel?.title;
  const typeCardSection = type ? CardTypeByCarouselType[type] : '';
  const cardsPerRow = typeCardSection ? getCardsPerRow(typeCardSection) : 5;

  function getSkeletonByType() {
    if (typeCardSection === 'LIVE') {
      return <CardLiveSkeleton dark numberOfCards={10} />;
    }
    return <CatalogVodSkeleton className="dtv-html5-c-see-all__catalog-skeleton" numberOfCards={10} />;
  }

  return (
    <ScrollView className="dtv-html5-c-see-all">
      <h1 className="dtv-html5-c-see-all__title">
        {sectionTitle}
      </h1>
      {isFetching
        ? getSkeletonByType()
        : (
          <CatalogAll
            className="dtv-html5-c-see-all__cards-container"
            cardsPerRow={cardsPerRow}
            items={items}
            focusFirstCard
            type={typeCardSection}
          />
        )}
    </ScrollView>
  );
}

Section.propTypes = {
  sourceProvider: PropTypes.string,
};

Section.defaultProps = {
  sourceProvider: '',
};

export default memo(Section);
